<template>
    <div ref="root" class="form-container" v-html="code"></div>
</template>

<script>
import { onMounted, ref } from 'vue';
const $ = window.jQuery;

export default {

    props: {
        code: {
            required: true,
            type: String
        }
    },
    
    setup(props) {

        const root = ref(null);

        onMounted(() => {
            $(root.value).find('.gfield_contains_required').each(function() {
                $(this).find('input').attr('required', '');
            });
        });

        return {
            root
        }

    }

}
</script>